// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Avaliacoes_ListCriteriaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /avaliacoes/avaliacoes/listCriteria.
 *
 * Returns the evaluation criteria keyed by criterion ID, as produced by
 * Avaliacoes_model::mapIDCriteria() (an ID => criterion map built from the
 * external avaliacoesApi `criteria/list` response). When the external
 * service returns nothing the map is empty.
 */
import type { Avaliacoes_ListCriteriaRow } from './Avaliacoes_ListCriteriaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Avaliacoes_ListCriteriaResponseDados = Avaliacoes_ListCriteriaRow[];

export type Avaliacoes_ListCriteriaResponse = ApiResponse<Avaliacoes_ListCriteriaResponseDados>;

registerResponseContract('Avaliacoes_ListCriteriaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:   { type: 'number',  required: true },
      name: { type: 'string',  required: true },
    },
  },
})
